import { combineReducers } from 'redux'
import flash from 'reducers/flash'
import createMetaReducer from 'reducers/meta'
import resources from 'reducers/resources'
import uiReducer from 'reducers/ui'
import { persistReducer } from 'redux-persist'
import settingsReducer from 'reducers/settings'
import { connectRouter } from 'connected-react-router'
import orm from 'models'
import { createReducer } from 'redux-orm'

import modelReducer from 'reducers/form/model-reducer'


export const createRootReducer = (history) => { return (state,action) => {
  if (action.type === 'CLEAR_STORE') {
    state = undefined
  }

  return combineReducers({
  // router: connectRouter(history),
  admin: () => { return true },
  flash: flash,

  entities: (state, action) => {
    const intermediateState = createReducer(orm) (state, action)
    const finalState = modelReducer(`entities`, {})(intermediateState, action)
    return finalState;
  },
  meta: createMetaReducer(orm),
  // FIXME scope admin on admin models
  settings:  persistReducer({key: 'settings', storage: localStorage}, settingsReducer),
  resources: resources, // TODO: make as entity
  ui: uiReducer
})(state,action)
}}
